import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {getMakeover} from "./getMakeOverDetail"
export const handlePayInvoice = createAsyncThunk("ListingMakeover/handlePayInvoice", async (data, thunkAPI) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/transactions/makeover/invoice/generate-check/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    thunkAPI.dispatch(getMakeover({id:data?.makeover_id}))
    return {...resp.data,...data};
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
